export const OktaClientId = '0oaop0jixngcdBAzt696'
